import { Box, Card, CardContent, Typography } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import { useScrollReveal } from '../use-scroll-reveal'

const FACE_SX = {
  position: 'absolute',
  inset: 0,
  backfaceVisibility: 'hidden',
  WebkitBackfaceVisibility: 'hidden',
}

export const FeatureCard = ({ feature, index, isFlipped, onFlip }) => {
  const { ref, visible } = useScrollReveal(0.15)
  const theme = useTheme()
  const screenshot = theme.palette.mode === 'dark' ? feature.screenshotDark : feature.screenshotLight
  const hoverBorderColor = theme.palette.mode === 'dark' ? theme.palette.primary.light : theme.palette.primary.dark

  return (
    <Box
      ref={ref}
      sx={{
        height: '100%',
        opacity: visible ? 1 : 0,
        transform: visible ? 'translateY(0)' : 'translateY(24px)',
        transition: `opacity 0.5s ease ${index * 0.08}s, transform 0.5s ease ${index * 0.08}s`,
      }}
    >
      <Box
        onClick={onFlip}
        sx={{
          position: 'relative',
          width: '100%',
          height: '100%',
          cursor: 'pointer',
          transformStyle: 'preserve-3d',
          transform: isFlipped ? 'perspective(1000px) rotateY(180deg)' : 'perspective(1000px) rotateY(0deg)',
          transition: 'transform 0.55s ease',
          '&:hover .feature-front': !isFlipped ? {
            transform: 'translateY(-2px)',
            boxShadow: theme.shadows[6],
            borderColor: hoverBorderColor,
          } : {},
        }}
      >
        {/* Front */}
        <Card
          className="feature-front"
          sx={{
            ...FACE_SX,
            border: '1px solid transparent',
            transition: 'transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease',
          }}
        >
          <CardContent sx={{ p: 3, display: 'flex', flexDirection: 'column', gap: 1.5 }}>
            <Box sx={{ color: 'primary.main' }}>{feature.icon}</Box>
            <Typography variant="h6" fontWeight={600}>{feature.title}</Typography>
            <Typography variant="body2" color="text.secondary">{feature.body}</Typography>
          </CardContent>
        </Card>

        {/* Back */}
        <Card
          sx={{
            ...FACE_SX,
            transform: 'rotateY(180deg)',
            overflow: 'hidden',
          }}
        >
          <Box
            component="img"
            src={screenshot}
            alt={feature.title}
            sx={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              objectPosition: 'center',
              display: 'block',
            }}
          />
        </Card>
      </Box>
    </Box>
  )
}
